"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Filter;

var _Popover2 = _interopRequireDefault(require("@material-ui/core/Popover"));

var _Add2 = _interopRequireDefault(require("@material-ui/icons/Add"));

var _Typography2 = _interopRequireDefault(require("@material-ui/core/Typography"));

var _IconButton2 = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _CloseRounded2 = _interopRequireDefault(require("@material-ui/icons/CloseRounded"));

var _FilterListRounded2 = _interopRequireDefault(require("@material-ui/icons/FilterListRounded"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _Autocomplete2 = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));

var _Chip2 = _interopRequireDefault(require("@material-ui/core/Chip"));

var _TextField2 = _interopRequireDefault(require("@material-ui/core/TextField"));

var _ArrowDropDownRounded2 = _interopRequireDefault(require("@material-ui/icons/ArrowDropDownRounded"));

var _Checkbox2 = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _styles = require("@material-ui/core/styles");

var _moment = _interopRequireDefault(require("moment"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("../components/Button"));

var _DateInput = _interopRequireDefault(require("../components/DateInput"));

var _icons = _interopRequireDefault(require("../icons"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    container: {
      width: 670
    },
    search: {
      borderBottom: "2px solid rgb(0 0 0 / 5%)"
    },
    list: {
      maxHeight: "70vh"
    },
    button: {
      backgroundColor: "#f3f4f6"
    },
    icon: {
      marginRight: 4,
      fontSize: 22
    },
    iconType: {
      "& svg": {
        fontSize: 16,
        marginRight: 6,
        marginTop: 2
      }
    }
  };
});
Filter.propTypes = {
  fields: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    type: _propTypes["default"].string,
    options: _propTypes["default"].object
  })),
  value: _propTypes["default"].array,
  onChange: _propTypes["default"].func,
  onSubmit: _propTypes["default"].func,
  onOpenInput: _propTypes["default"].func,
  onClose: _propTypes["default"].func
};
Filter.defaultProps = {
  fields: [],
  value: {},
  onChange: function onChange() {}
}; // constans

var filterOptionText = [{
  name: "is"
}, {
  name: "is not"
}, {
  name: "contains"
}, {
  name: "not contains"
}];
var filterOptionNumber = [{
  name: "="
}, {
  name: "≠"
}, {
  name: ">"
}, {
  name: "<"
}, {
  name: "≤"
}, {
  name: "≥"
}];
var filterOptionLinkToRecod = [{
  name: "includes"
}, {
  name: "not includes"
}];
var typeNumber = ["number", "currency", "duration", "percent", "count", "autoNumber", "rating"];
var typeDate = ["date", "createdAt", "updatedAt"];

function Filter(_ref) {
  var fields = _ref.fields,
      value = _ref.value,
      onChange = _ref.onChange,
      _onSubmit = _ref.onSubmit,
      onOpenInput = _ref.onOpenInput,
      onClose = _ref.onClose;
  var classes = useStyles();

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);

    if (onClose) {
      onClose(value);
    }
  };

  var options = (0, _react.useMemo)(function () {
    return fields;
  }, [fields]);

  var handleAdd = function handleAdd() {
    var newValue = _toConsumableArray(value);

    newValue.push({
      key: options[0].name,
      value: "",
      operator: "is"
    });
    onChange(newValue);
  };

  var handleChangeKey = function handleChangeKey(index) {
    return function (e, data) {
      var newValue = _toConsumableArray(value);

      newValue[index]["key"] = data.name;
      var field = fields.find(function (v) {
        return v.name === data.name;
      });
      var isNumber = typeNumber.includes(field.type);
      var isDate = typeDate.includes(field.type);

      if (isNumber || isDate) {
        newValue[index]["operator"] = "=";
      } else if (["linkToRecord", "collaborator", "createdBy", "updatedBy", "multiSelect"].includes(field.type)) {
        newValue[index]["operator"] = "includes";
      } else {
        newValue[index]["operator"] = "is";
      }

      onChange(newValue);
    };
  };

  var handleChangeOperator = function handleChangeOperator(index) {
    return function (e, data) {
      var newValue = _toConsumableArray(value);

      newValue[index]["operator"] = data.name;
      onChange(newValue);
    };
  };

  var handleChangeValue = function handleChangeValue(index, data) {
    var newValue = _toConsumableArray(value);

    newValue[index]["value"] = data;
    onChange(newValue);
  };

  var handleDelete = function handleDelete(index) {
    var newValue = _toConsumableArray(value);

    newValue.splice(index, 1);
    onChange(newValue);
  };

  var inputField = function inputField(item, index) {
    var field = fields.find(function (v) {
      return v.name === item.key;
    }) || {};
    var type = field.type;

    if (type === "checkBox") {
      return /*#__PURE__*/_react["default"].createElement(_Checkbox2["default"], {
        size: "small",
        checked: Boolean(item.value),
        onChange: function onChange(e) {
          return handleChangeValue(index, e.target.checked);
        }
      });
    }

    if (type === "singleSelect" || type === "multiSelect") {
      var _field$options;

      var _options = ((_field$options = field.options) === null || _field$options === void 0 ? void 0 : _field$options.options) || [];

      var valueInput = Array.isArray(item.value) ? item.value : [];

      if (type === "singleSelect") {
        var _valueInput$;

        valueInput = typeof item.value === "string" ? [{
          value: item.value
        }] : _typeof(item.value) === "object" ? [item.value] : [];

        if (!((_valueInput$ = valueInput[0]) !== null && _valueInput$ !== void 0 && _valueInput$.value)) {
          valueInput = [_options[0]] || [];
          handleChangeValue(index, _options[0]);
        }
      }

      return /*#__PURE__*/_react["default"].createElement(_Autocomplete2["default"], {
        multiple: true,
        options: _options,
        getOptionLabel: function getOptionLabel(option) {
          return option.value;
        },
        disableClearable: true,
        popupIcon: /*#__PURE__*/_react["default"].createElement(_ArrowDropDownRounded2["default"], null),
        value: valueInput,
        onChange: function onChange(e, data) {
          console.log("data : ", data);
          handleChangeValue(index, type === "multiSelect" ? data : data[data.length - 1]);
        },
        renderInput: function renderInput(params) {
          return /*#__PURE__*/_react["default"].createElement(_TextField2["default"], _extends({}, params, {
            InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
              style: {
                fontSize: 14,
                paddingTop: 4,
                paddingBottom: 4,
                minHeight: 38
              }
            }),
            fullWidth: true,
            size: "small",
            variant: "outlined"
          }));
        },
        renderOption: function renderOption(option) {
          return /*#__PURE__*/_react["default"].createElement(_Chip2["default"], {
            style: {
              color: "white",
              backgroundColor: option.color || "blue"
            },
            size: "small",
            label: option.value,
            color: "primary"
          });
        },
        renderTags: function renderTags(values, getTagProps) {
          return values.map(function (option, index) {
            return /*#__PURE__*/_react["default"].createElement(_Chip2["default"], _extends({
              key: option.value,
              label: option.value,
              style: {
                color: "white",
                backgroundColor: option.color || "blue",
                maxWidth: "35%"
              },
              color: "primary",
              size: "small"
            }, getTagProps({
              index: index
            })));
          });
        }
      });
    }

    if (["linkToRecord", "collaborator", "createdBy", "updatedBy"].includes(type)) {
      var _options2 = [];
      return /*#__PURE__*/_react["default"].createElement(_Autocomplete2["default"], {
        multiple: true,
        options: _options2,
        getOptionLabel: function getOptionLabel(option) {
          return option.value;
        },
        disableClearable: true,
        openOnFocus: true,
        popupIcon: /*#__PURE__*/_react["default"].createElement(_ArrowDropDownRounded2["default"], null),
        value: Array.isArray(item.value) ? item.value : [],
        onChange: function onChange(e, data) {
          return handleChangeValue(index, data);
        },
        onOpen: function onOpen(event) {
          return onOpenInput === null || onOpenInput === void 0 ? void 0 : onOpenInput({
            event: event,
            field: field,
            index: index,
            item: item
          });
        },
        noOptionsText: "Select data",
        renderInput: function renderInput(params) {
          return /*#__PURE__*/_react["default"].createElement(_TextField2["default"], _extends({}, params, {
            InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
              style: {
                fontSize: 14,
                paddingTop: 4,
                paddingBottom: 4,
                minHeight: 38
              }
            }),
            fullWidth: true,
            size: "small",
            variant: "outlined"
          }));
        },
        renderOption: function renderOption(option) {
          return /*#__PURE__*/_react["default"].createElement(_Chip2["default"], {
            style: {
              color: "white",
              backgroundColor: option.color || "blue"
            },
            size: "small",
            label: option.value,
            color: "primary"
          });
        },
        renderTags: function renderTags(values, getTagProps) {
          return values.map(function (option, index) {
            return /*#__PURE__*/_react["default"].createElement(_Chip2["default"], _extends({
              key: option.value,
              label: option.value,
              style: {
                color: "white",
                backgroundColor: option.color || "blue",
                maxWidth: "35%"
              },
              color: "primary",
              size: "small"
            }, getTagProps({
              index: index
            })));
          });
        }
      });
    }

    if (type === "date") {
      var _field$options2;

      var includeTime = (_field$options2 = field.options) === null || _field$options2 === void 0 ? void 0 : _field$options2.includeTimeField;

      var _value = item.value ? (0, _moment["default"])(item.value, includeTime ? null : "YYYY-MM-DD") : null;

      return /*#__PURE__*/_react["default"].createElement(_Box2["default"], null, /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
        options: field.options,
        value: _value,
        onChange: function onChange(data) {
          var newValue = data.toISOString();

          if (!includeTime) {
            newValue = (0, _moment["default"])(data).format("YYYY-MM-DD");
          }

          handleChangeValue(index, newValue);
        }
      }));
    }

    if (["createdAt", "updatedAt"].includes(type)) {
      var _value2 = item.value ? (0, _moment["default"])(item.value) : null;

      return /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
        options: {
          includeTimeField: true
        },
        value: _value2,
        onChange: function onChange(data) {
          var newValue = data.toISOString();
          handleChangeValue(index, newValue);
        }
      });
    }

    var isNumber = typeNumber.includes(type);
    var fieldType = "text";

    if (isNumber) {
      fieldType = "number";
    }

    if (type === "email") {
      fieldType = "email";
    }

    return /*#__PURE__*/_react["default"].createElement(_TextField2["default"], {
      fullWidth: true,
      value: typeof item.value === "string" ? item.value : "",
      InputProps: {
        style: {
          fontSize: 14
        }
      },
      placeholder: "Enter a value",
      size: "small",
      type: fieldType,
      variant: "outlined",
      onChange: function onChange(e) {
        return handleChangeValue(index, e.target.value);
      }
    });
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    style: value.length > 0 ? {
      backgroundColor: "#fee2d5"
    } : {},
    onClick: handleClick,
    size: "small"
  }, /*#__PURE__*/_react["default"].createElement(_FilterListRounded2["default"], {
    className: classes.icon
  }), value.length > 0 ? "Filtered ".concat(value.length, " field") : "Filter"), /*#__PURE__*/_react["default"].createElement(_Popover2["default"], {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: handleClose,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      _onSubmit(value);

      handleClose();
    }
  }, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    className: classes.container
  }, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    pt: 2,
    px: 2,
    className: classes.list
  }, value.map(function (item, index) {
    var name = item.key;
    var field = fields.find(function (v) {
      return v.name === item.key;
    }) || {};
    var type = field.type;
    var isNumber = typeNumber.includes(type);
    var isDate = typeDate.includes(type);
    var filterOptions = filterOptionText;

    if (isNumber || isDate) {
      filterOptions = filterOptionNumber;
    }

    if (["linkToRecord", "collaborator", "createdBy", "updatedBy", "multiSelect"].includes(type)) {
      filterOptions = filterOptionLinkToRecod;
    }

    return /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
      style: {
        marginBottom: 10
      },
      alignItems: "center",
      key: name,
      display: "flex"
    }, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
      style: {
        minWidth: 80,
        marginTop: 2
      },
      alignItems: "center",
      display: "flex"
    }, /*#__PURE__*/_react["default"].createElement(_IconButton2["default"], {
      onClick: function onClick() {
        return handleDelete(index);
      },
      size: "small"
    }, /*#__PURE__*/_react["default"].createElement(_CloseRounded2["default"], {
      fontSize: "small"
    })), /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
      variant: "body2"
    }, index === 0 ? "where" : "and")), /*#__PURE__*/_react["default"].createElement(_Autocomplete2["default"], {
      options: options,
      getOptionLabel: function getOptionLabel(option) {
        return option.name;
      },
      disableClearable: true,
      popupIcon: /*#__PURE__*/_react["default"].createElement(_ArrowDropDownRounded2["default"], null),
      onChange: handleChangeKey(index),
      getOptionSelected: function getOptionSelected(option, value) {
        return option.name === value.name;
      },
      value: {
        name: name
      },
      renderInput: function renderInput(params) {
        return /*#__PURE__*/_react["default"].createElement(_TextField2["default"], _extends({}, params, {
          InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
            style: {
              fontSize: 14,
              width: 200
            }
          }),
          fullWidth: true,
          size: "small",
          variant: "outlined"
        }));
      },
      renderOption: function renderOption(option) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
          display: "flex"
        }, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
          className: classes.iconType
        }, _icons["default"][option.type]), /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
          variant: "body2"
        }, option.name)));
      }
    }), /*#__PURE__*/_react["default"].createElement(_Autocomplete2["default"], {
      options: filterOptions,
      getOptionLabel: function getOptionLabel(option) {
        return option.name;
      },
      getOptionSelected: function getOptionSelected(option, value) {
        return option.name === value.name;
      },
      disableClearable: true,
      popupIcon: /*#__PURE__*/_react["default"].createElement(_ArrowDropDownRounded2["default"], null),
      onChange: handleChangeOperator(index),
      value: {
        name: item.operator
      },
      renderInput: function renderInput(params) {
        return /*#__PURE__*/_react["default"].createElement(_TextField2["default"], _extends({}, params, {
          InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
            style: {
              fontSize: 14,
              width: 120,
              marginLeft: 4
            }
          }),
          fullWidth: true,
          size: "small",
          variant: "outlined"
        }));
      },
      renderOption: function renderOption(option) {
        return /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
          variant: "body2"
        }, option.name);
      }
    }), /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
      style: {
        marginLeft: 4,
        width: 228
      }
    }, inputField(item, index)));
  }), value.length === 0 && /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    mb: 1
  }, /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
    variant: "body2",
    color: "textSecondary"
  }, "No filters applied to this view"))), /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    p: 2,
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: handleAdd,
    startIcon: /*#__PURE__*/_react["default"].createElement(_Add2["default"], null),
    variant: "outlined",
    size: "small"
  }, "Add Filter"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    type: "submit",
    color: "primary",
    variant: "contained",
    size: "small"
  }, "Apply"))))));
}